module.exports = __webpack_public_path__ + "static/media/dimentha-partner.14e85d90.svg";